import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SearchIcon from "@mui/icons-material/Search";
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BoltIcon from '@mui/icons-material/Bolt';

import UserProfile from "./UserProfile";
import * as S from "./ChatInterfaceStyles";
import { useAuth } from '../context/AuthContext';

interface ChatHeaderProps {
  title: string;
  onNewConversation: () => void;
  onShowNotifications?: () => void;
  onShowSummary?: () => void;
  onShowActionItems?: () => void;
  onShowManualWorkflow?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  onNewConversation,
  onShowNotifications,
  onShowSummary,
  onShowActionItems,
  onShowManualWorkflow,
}) => {
  const { user, updatePreferences } = useAuth() as any;
  const isDarkMode = user?.preferences?.darkMode || false;

  const toggleTheme = () => {
    const newDarkMode = !isDarkMode;
    if (updatePreferences) updatePreferences({ darkMode: newDarkMode });
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  return (
    <S.Header>
      <S.HeaderTitle>{title}</S.HeaderTitle>

      <S.HeaderActions>
        <S.HeaderSearch>
          <S.HeaderSearchIcon>
            <SearchIcon sx={{ fontSize: 18 }} />
          </S.HeaderSearchIcon>
          <S.HeaderSearchInput placeholder="Search agents, users, or logs..." />
        </S.HeaderSearch>

        {onShowManualWorkflow && (
          <S.IconButton
            onClick={onShowManualWorkflow}
            title="Manual Workflow"
          >
            <BoltIcon sx={{ color: "#eab308" }} />
          </S.IconButton>
        )}

        <S.IconButton
          onClick={onNewConversation}
          title="Start New Conversation"
        >
          <AddCircleIcon sx={{ color: "#2563eb" }} />
        </S.IconButton>

        {/* Notifications */}
        <S.IconButton
          title="Notifications"
          onClick={onShowNotifications}
        >
          <NotificationsIcon sx={{ color: "#64748b" }} />
        </S.IconButton>

        {/* Summary */}
        <S.IconButton
          title="Summary"
          onClick={onShowSummary}
        >
          <ListAltIcon sx={{ color: "#64748b" }} />
        </S.IconButton>

        <S.IconButton
          title="Theme"
          onClick={toggleTheme}
        >
          {isDarkMode ?
            <LightModeOutlinedIcon sx={{ color: "#64748b" }} /> :
            <DarkModeOutlinedIcon sx={{ color: "#64748b" }} />
          }
        </S.IconButton>



        {/* User Profile */}
        <S.IconButton title="User Profile">
          <UserProfile />
        </S.IconButton>
      </S.HeaderActions>
    </S.Header>
  );
};

export default ChatHeader;
